import React from 'react';
import { getColor } from 'utils/colors';
import axios from 'axios';
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  CardGroup,
  CardDeck,
  Row,
  Col,
  ListGroup,
  ListGroupItem,
  Badge,
  CardText,
  CardLink,
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from 'reactstrap';

import { overlayCards, bgCards, gradientCards } from 'demos/cardPage';

import {
  MdInsertChart,
  MdBubbleChart,
  MdPieChart,
  MdShowChart,
  MdPersonPin,
  MdRateReview,
  MdThumbUp,
  MdShare,
} from 'react-icons/lib/md';

import InfiniteCalendar from 'react-infinite-calendar';
import { randomNum } from 'utils/demos';
import { Line, Bar } from 'react-chartjs-2';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import {
  supportTicketsData,
  productsData,
  userProgressTableData,
  avatarsData,
  todosData,
  chartjs,
} from 'demos/dashboardPage';
import { getStackLineChart, stackLineChartOptions } from 'demos/chartjs';

import Page from 'components/Page';

import SupportTicket from 'components/SupportTicket';
import ProductMedia from 'components/ProductMedia';
import UserProgressTable from 'components/UserProgressTable';

import { AnnouncementCard, TodosCard } from 'components/Card';

import { NumberWidget, IconWidget } from 'components/Widget';

import MapWithBubbles from 'components/MapWithBubbles';
import HorizontalAvatarList from 'components/HorizontalAvatarList';



const today = new Date();
const lastWeek = new Date(
  today.getFullYear(),
  today.getMonth(),
  today.getDate() - 7
);

class DashboardPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      modal: false,
      modal_backdrop: false,
      modal_nested_parent: false,
    modal_nested: false,
    backdrop: true,
      asassmentall:[],
      countkerusakanbytingkat:[],
      countkerusakanbybagian:[],
      countkerusakanbykec:[],
      countkerusakanbykab:[],
      namakec:[],
      totkec:[],
      namakab:[],
      totkab:[],
      kerugiantotal:0,
      kerugiankablotim:[],
      kerugiankablotur:[],
      kerugiankablobar:[],
      kerugiankabloteng:[],
      kerugiankabmataram:[],
      kerugiankec:[],
      datakerugian:[],
      statuskecpending:[],
      statuskecditerima:[],
      penanganan:0,
    };
  }

  componentWillMount(){
    
    toast("Selamat Datang ",{
      position: toast.POSITION.BOTTOM_CENTER,
      position: "top-right",
autoClose: 5000,
hideProgressBar: false,
closeOnClick: true,
pauseOnHover: true,
draggable: true,
    });

    axios.get('https://backendmha.herokuapp.com/api/countkerusakanbykab')
    .then(res => {

      for (var i = 0; i < res.data.length; i++) {    
        this.state.namakab.push(res.data[i].kab)
        this.state.totkab.push(res.data[i].total)
      }

      console.log("INI CHART"+ JSON.stringify(this.state.namakab));
      console.log("INI CHART"+ JSON.stringify(this.state.totkab));

      // const countkerusakanbykab = res.data
      // this.setState({ countkerusakanbykab });

      // console.log("INI2"+ JSON.parse(JSON.stringify(res)));
      // console.log("INI1"+ JSON.parse(JSON.stringify(countkerusakanbykab) ));
      // console.log("INI STRING KU "+ JSON.parse(countkerusakanbykab[3].kab));

    }) 

    axios.get('https://backendmha.herokuapp.com/api/countkerusakanbykec')
    .then(res => {

      for (var i = 0; i < res.data.length; i++) {    
        this.state.namakec.push(res.data[i].kec)
        this.state.totkec.push(res.data[i].total)
      }

      // const countkerusakanbykec = res.data;
      // this.setState({ countkerusakanbykec });
      // console.log("INI CHART"+ JSON.stringify(this.state.namakec));
      // console.log("INI CHART"+ JSON.stringify(this.state.totkec));
    }) 
  

  }

  componentDidMount() {

    axios.get('https://backendmha.herokuapp.com/api/counthargakab')
    .then(res => {
      const kerugiankablotur = res.data[0];
      const kerugiankablobar = res.data[4];
      const kerugiankabloteng = res.data[3];
      const kerugiankablotim = res.data[2];
      const kerugiankabmataram = res.data[1];
      this.setState({ kerugiankablotur,kerugiankablobar,kerugiankabloteng, kerugiankablotim,kerugiankabmataram});
    }) 

    axios.get('https://backendmha.herokuapp.com/api/counthargakec')
    .then(res => {
      for (var i = 0; i < res.data.length; i++) {    
        this.state.datakerugian.push(res.data[i].total)
      }
    }) 

    axios.get('https://backendmha.herokuapp.com/api/countstatus')
    .then(res => {
      for (var i = 0; i < res.data.statuskec.length; i++) {    
        this.state.statuskecpending.push(res.data.statuskecpen[i].total)
        this.state.statuskecditerima.push(res.data.statuskec[i].total)
      }

      console.log("INI CHART STATUS "+ this.state.statuskecpending);
      console.log("INI CHART STATUS2 "+ this.state.statuskecditerima);

    }) 

    axios.get('https://backendmha.herokuapp.com/api/countstatus')
    .then(res => {
      const penanganan = res.data.statusall[1].total;
      this.setState({ penanganan });
    }) 
    

    axios.get('https://backendmha.herokuapp.com/api/asassmentcount')
    .then(res => {
      const asassmentall = res.data;
      this.setState({ asassmentall });
    }) 

    axios.get('https://backendmha.herokuapp.com/api/countkerusakanbytingkat')
    .then(res => {
      const countkerusakanbytingkat = res.data;
      this.setState({ countkerusakanbytingkat });

    }) 

    axios.get('https://backendmha.herokuapp.com/api/countkerusakanbybagian')
    .then(res => {
      const countkerusakanbybagian = res.data;
      this.setState({ countkerusakanbybagian });

    }) 

    axios.get('https://backendmha.herokuapp.com/api/countharga')
    .then(res => {
      const kerugiantotal = res.data[0].total;
      // console.log("KERUGIAN TOTAL"+ JSON.stringify(res.data.total));
      // console.log("KERUGIAN TOTAL PARSE "+ JSON.parse(JSON.stringify(res.data)));
      this.setState({ kerugiantotal : kerugiantotal});
      // console.log("KERUGIAN"+ this.state.kerugiantotal[0].total);
    }) 
  
    
    
    // this is needed, because InfiniteCalendar forces window scroll
    // window.scrollTo(0, 0);

    // if (this.state.kerugiankab.length > 0) {
    //   console.log(this.state.kerugiankab[0].kab);
    // }

    // console.log("KABUPATEN "+ this.state.kerugiankab[0].kab);
  }

  
  toggle = modalType => () => {
    if (!modalType) {
      return this.setState({
        modal: !this.state.modal,
      });
    }

    this.setState({
      [`modal_${modalType}`]: !this.state[`modal_${modalType}`],
    });
  };

  render() {

    const MONTHS = ['Gerung', 'Gunung Sari', 'Lingsar', 'Sekotong', 'Labuapi', 'Kediri', 'Lembar', 'Batu Layar', 'Kuripan', 'Narmada'];

    const KECAMATAN = ['Sekotong', 'Narmada', 'Lingsar', 'Lembar', 'Labuapi', 'Kuripan', 'Kediri', 'Gunungsari', 'Gerung', 'Batu Layar'];


    const genLineData2 = (moreData = {}, moreData2 = {}) => {
      return {
        labels: KECAMATAN,
        datasets: [
          {
            label: 'Pending',
            backgroundColor: getColor('primary'),
            borderColor: getColor('primary'),
            borderWidth: 1,
            data: this.state.statuskecpending
          },
          {
            label: 'Diterima',
            backgroundColor: getColor('secondary'),
            borderColor: getColor('secondary'),
            borderWidth: 1,
            data: this.state.statuskecditerima
          },
        ],
      };
    };

const genLineData = (moreData = {}, moreData2 = {}) => {
  return {
    labels: MONTHS,
    datasets: [
      {
        label: 'Rp.',
        backgroundColor: getColor('primary'),
        borderColor: getColor('primary'),
        borderWidth: 1,
        data: this.state.datakerugian
      },
    ],
  };
};

    // for (var i = 0; i < this.state.countkerusakanbykab.length; i++) {    
    //   this.state.namakab.push(this.state.countkerusakanbykab[i].kab)
    //   this.state.totkab.push(this.state.countkerusakanbykab[i].total)
    // }

    // for (var i = 0; i < this.state.countkerusakanbykab.length; i++) {    
    //   this.state.namakec.push(this.state.countkerusakanbykec[i].kec)
    //   this.state.totkec.push(this.state.countkerusakanbykec[i].total)
    // }

    const databar = {
      labels: this.state.namakec,
  datasets: [
    {
      label: 'Kerusakan',
      backgroundColor: 'rgba(255,99,132,0.2)',
      borderColor: 'rgba(255,99,132,1)',
      borderWidth: 1,
      hoverBackgroundColor: 'rgba(255,99,132,0.4)',
      hoverBorderColor: 'rgba(255,99,132,1)',
      data: this.state.totkec
    }
  ]
    };
  
    const dataline = {
      labels: this.state.namakab,
  datasets: [
    {
      label: 'Kerusakan',
      fill: true,
      lineTension: 0.1,
      backgroundColor: 'rgba(75,192,192,0.4)',
      borderColor: 'rgba(75,192,192,1)',
      borderCapStyle: 'butt',
      borderDashOffset: 0.0,
      borderJoinStyle: 'miter',
      pointBorderColor: 'rgba(75,192,192,1)',
      pointBackgroundColor: '#fff',
      pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      pointHoverBorderColor: 'rgba(220,220,220,1)',
      pointHoverBorderWidth: 2,
      pointRadius: 1,
      pointHitRadius: 10,
      data: this.state.totkab
    }
  ]
    };


    const asassmentall = this.state.asassmentall.countall;
    const countringan = this.state.countkerusakanbytingkat.ringan;
    const countsedang = this.state.countkerusakanbytingkat.sedang;
    const countberat = this.state.countkerusakanbytingkat.berat;

    const primaryColor = getColor('primary');
    const secondaryColor = getColor('secondary');

    return (
      <Page
        className="DashboardPage"
        title="Beranda"
        breadcrumbs={[{ name: 'Beranda', active: true }]}>
        <Row>
        <ToastContainer />
          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Total Kerusakan"
              // subtitle="This month"
              number={this.state.asassmentall.countall}
              color="secondary"
              progress={{
                value: 100,
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Rusak Ringan"
              // subtitle="This month"
              number={this.state.countkerusakanbytingkat.ringan}
              color="secondary"
              progress={{
                value: ((countsedang/asassmentall)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Rusak Sedang"
              // subtitle="This month"
              number={this.state.countkerusakanbytingkat.sedang}
              color="secondary"
              progress={{
                value: ((countsedang/asassmentall)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Rusak Berat"
              // subtitle="This month"
              number={this.state.countkerusakanbytingkat.berat}
              color="secondary"
              progress={{
                value: ((countberat/asassmentall)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>
        </Row>
        

        <Row>
          <Col lg="8" md="12" sm="12" xs="12">
            <Card>
              <CardHeader>
                Grafik KERUSAKAN{' '}
                <small className="text-muted text-capitalize">per kabupaten</small>
              </CardHeader>
              <CardBody>
                <Line data={dataline} options={chartjs.line.options} />
              </CardBody>
            </Card>
          </Col>

          <Col lg="4" md="12" sm="12" xs="12">
            <Card>
              <CardHeader>Grafik Daerah</CardHeader>
              <CardBody>
                <Bar data={databar} options={chartjs.bar.options} />
              </CardBody>
              <ListGroup flush>
                <ListGroupItem>
                  <MdInsertChart size={25} color={primaryColor} /> Kerusakan Pondasi{' '}
                  <Badge color="secondary">{this.state.countkerusakanbybagian.pondasi}</Badge>
                </ListGroupItem>
                <ListGroupItem>
                  <MdBubbleChart size={25} color={primaryColor} /> Kerusakan Kolom <Badge color="secondary">{this.state.countkerusakanbybagian.kolom}</Badge>
                </ListGroupItem>
                <ListGroupItem>
                  <MdShowChart size={25} color={primaryColor} /> Kerusakan Atap{' '}
                  <Badge color="secondary">{this.state.countkerusakanbybagian.atap}</Badge>
                </ListGroupItem>
                <ListGroupItem>
                  <MdPieChart size={25} color={primaryColor} /> Kerusakan Langit <Badge color="secondary">{this.state.countkerusakanbybagian.langit}</Badge>
                </ListGroupItem>
                <ListGroupItem>
                  <MdPieChart size={25} color={primaryColor} /> Kerusakan Dinding <Badge color="secondary">{this.state.countkerusakanbybagian.dinding}</Badge>
                </ListGroupItem>
                <ListGroupItem>
                  <MdPieChart size={25} color={primaryColor} /> Kerusakan Lantai <Badge color="secondary">{this.state.countkerusakanbybagian.lantai}</Badge>
                </ListGroupItem>
              </ListGroup>
            </Card>
          </Col>
        </Row>

        <Row>
        <ToastContainer />
          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Total Kerugian"
              // subtitle="This month"
              number={'Rp.'+this.state.kerugiantotal}
              color="secondary"
              progress={{
                value: 100,
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Lombok Timur"
              // subtitle="This month"
              number= {'Rp.'+this.state.kerugiankablotim.total}
              color="secondary"
              progress={{
                value: ((this.state.kerugiankablotim.total/this.state.kerugiantotal)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Lombok Tengah"
              // subtitle="This month"
              number={'Rp.'+this.state.kerugiankabloteng.total}
              color="secondary"
              progress={{
                value: ((this.state.kerugiankabloteng.total/this.state.kerugiantotal)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Lombok Barat"
              // subtitle="This month"
              number={'Rp.'+this.state.kerugiankablobar.total}
              color="secondary"
              progress={{
                value: ((this.state.kerugiankablobar.total/this.state.kerugiantotal)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Lombok Utara"
              // subtitle="This month"
              number={'Rp.'+this.state.kerugiankablotur.total}
              color="secondary"
              progress={{
                value: ((this.state.kerugiankablotur.total/this.state.kerugiantotal)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Kota Mataram"
              // subtitle="This month"
              number={'Rp.'+this.state.kerugiankabmataram.total}
              color="secondary"
              progress={{
                value: ((this.state.kerugiankabmataram.total/this.state.kerugiantotal)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>

          <Col lg={3} md={6} sm={6} xs={12}>
            <NumberWidget
              title="Penanganan"
              // subtitle="This month"
              number={this.state.penanganan}
              color="secondary"
              progress={{
                value:((this.state.penanganan/this.state.asassmentall.countall)*100).toPrecision(2),
                label: 'Persentase',
              }}
            />
          </Col>



          {['right'].map(color => (
          <Col lg={3} md={6} sm={6} xs={12}>
            <Card
              inverse
              className={`border-0 bg-gradient-theme${
                !!color ? '-' : ''
              }${color}`}
              style={{
                height: 108,
              }}>

              <CardBody className="d-flex justify-content-between align-items-center">
                <CardText>Kecamatan</CardText>
                <Button onClick={this.toggle()} outline color="light">
                  Detail
                </Button>
              </CardBody>
            </Card>
          </Col>
        ))}

    

          <Modal  style={{width:'1500px'}}
                  isOpen={this.state.modal}
                  toggle={this.toggle()}
                    backdrop={this.state.backdrop}
                  className={this.props.className}>
                  <ModalHeader toggle={this.toggle()}>Detail</ModalHeader>
                  <ModalBody>
                 
                  <Card>
            <CardHeader>Kerugian tingkat Kecamatan</CardHeader>
            <CardBody>
            <Bar data={genLineData({ type: 'bar', fill: false })} />
            </CardBody>
          </Card>

                  <Card>
            <CardHeader>Penanggulangan tingkat Kecamatan</CardHeader>
            <CardBody>
              <Line
                data={genLineData2()}
                options={{
                  scales: {
                    xAxes: [
                      {
                        scaleLabel: {
                          display: true,
                          labelString: 'Kecamatan',
                        },
                      },
                    ],
                    yAxes: [
                      {
                        stacked: true,
                        scaleLabel: {
                          display: true,
                          labelString: 'Penanggulangan',
                        },
                      },
                    ],
                  },
                }}
              />
            </CardBody>
          </Card>
                  </ModalBody>
                  <ModalFooter>
                    {/* <Button color="primary" onClick={this.toggle()}>
                      Do Something
                    </Button>{' '} */}
                    <Button color="secondary" onClick={this.toggle()}>
                      Keluar
                    </Button>
                  </ModalFooter>
                </Modal>

          

        </Row>

        {/* <CardGroup style={{ marginBottom: '1rem' }}>
          <IconWidget
            bgColor="white"
            inverse={false}
            icon={MdThumbUp}
            title="50+ Likes"
            subtitle="People you like"
          />
          <IconWidget
            bgColor="white"
            inverse={false}
            icon={MdRateReview}
            title="10+ Reviews"
            subtitle="New Reviews"
          />
          <IconWidget
            bgColor="white"
            inverse={false}
            icon={MdShare}
            title="30+ Shares"
            subtitle="New Shares"
          />
        </CardGroup>  */}

        {/* <Row>
          <Col md="6" sm="12" xs="12">
            <Card>
              <CardHeader>New Products</CardHeader>
              <CardBody>
                {productsData.map(
                  ({ id, image, title, description, right }) => (
                    <ProductMedia
                      key={id}
                      image={image}
                      title={title}
                      description={description}
                      right={right}
                    />
                  )
                )}
              </CardBody>
            </Card>
          </Col>

          <Col md="6" sm="12" xs="12">
            <Card>
              <CardHeader>New Users</CardHeader>
              <CardBody>
                <UserProgressTable
                  headers={[
                    <MdPersonPin size={25} />,
                    'name',
                    'date',
                    'participation',
                    '%',
                  ]}
                  usersData={userProgressTableData}
                />
              </CardBody>
            </Card>
          </Col>
        </Row> */}

        <Row>
         

          
        </Row>
      </Page>
    );
  }
}
export default DashboardPage;
